import type { TGetConfigResponse, TUpdateConfigRequest } from "./reportCard.interfaces";

/**
 * Builds a full PUT body from GET /v1/report-card/config.
 *
 * OpenAPI mismatch: `GetConfigResponse` describes editable field metadata and
 * branding, while `UpdateConfigRequest` uses flat branding/toggles/labels.
 * Confirmed mapping: branding → logo/header/footer/primaryColor;
 * displayOptions → show*; editable field `label` strings → *Label fields on PUT.
 * `defaultTemplate` is not returned on GET; pass it via `overrides` (e.g. from
 * the selected template’s `name` in GET /templates).
 */
export function mapGetConfigToUpdateRequest(
  config: TGetConfigResponse,
  overrides?: Partial<TUpdateConfigRequest>,
): TUpdateConfigRequest {
  const { branding, displayOptions, editableFields, availableTemplates } =
    config;

  const base: TUpdateConfigRequest = {
    logoUrl: branding.logoUrl ?? "",
    headerText: branding.headerText ?? "",
    footerText: branding.footerText ?? "",
    primaryColor: branding.primaryColor ?? "",
    showAttendance: displayOptions.showAttendance,
    showConduct: displayOptions.showConduct,
    showRemarks: displayOptions.showRemarks,
    classTeacherLabel: editableFields.classTeacherName.label,
    principalLabel: editableFields.principalName.label,
    extraFields: {},
    defaultTemplate: availableTemplates[0] ?? "",
  };

  return { ...base, ...overrides };
}
